import PageBreadcrumb, {
  PageBreadcrumbItem
} from 'components/common/PageBreadcrumb';
import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Props, Type } from './career.type';
import Error404 from 'pages/error/Error404';
import { Nav, Tab } from 'react-bootstrap';
import JobPost from 'pages/job/JobPost';
import Internship from 'pages/job/internship/Internship';

const defaultBreadcrumbItems: Record<Type, PageBreadcrumbItem[]> = {
  internships: [
    {
      label: 'Internships',
      url: '/panel/recruitment/careers/internships',
      active: true
    }
  ],
  jobs: [
    {
      label: 'Jobs Post',
      url: '/panel/recruitment/careers/jobs',
      active: true
    }
  ]
};

const titleMap: Record<Type, string> = {
  internships: 'Internship',
  jobs: 'Job Post'
};

function Career({ type }: Props) {
  const navigate = useNavigate();

  useEffect(() => {
    if (!type) {
      navigate('/panel/recruitment/careers/jobs');
    }
  }, []);

  return type === 'internships' || type === 'jobs' ? (
    <div>
      <PageBreadcrumb items={defaultBreadcrumbItems[type]} />
      <div className="mb-2">
        <h2>{titleMap[type]}</h2>
      </div>
      <Tab.Container activeKey={type}>
        <Nav variant="underline" className="mb-3">
          <Nav.Item>
            <Nav.Link
              as={Link}
              to="/panel/recruitment/careers/jobs"
              eventKey="jobs"
            >
              Jobs
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link
              as={Link}
              to="/panel/recruitment/careers/internships"
              eventKey="internships"
            >
              Internships
            </Nav.Link>
          </Nav.Item>
        </Nav>
        <Tab.Content>
          <Tab.Pane eventKey="jobs">
            <JobPost />
          </Tab.Pane>
          <Tab.Pane eventKey="internships">
            <Internship />
          </Tab.Pane>
        </Tab.Content>
      </Tab.Container>
    </div>
  ) : (
    <Error404 />
  );
}

export default Career;
